// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hKEH","placeholdersHeader":"styles_placeholdersHeader__24tgE","editorStyle":"styles_editorStyle__1NzyS","placeholdersBox":"styles_placeholdersBox__294Yy"};